"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = require("./styled");
var Typo_1 = require("../../../components/Typo");
var contextApi_1 = require("./contextApi");
var colors_1 = require("../../themes/colors");
var DisplayIcon_1 = require("../../../utils/comps/DisplayIcon");
var Buttons_1 = require("../../../components/Buttons");
var Modal_1 = require("../../../components/Modals/Modal");
var mixins_1 = require("../../../themes/mixins");
var useScreenWidth_1 = require("../../../utils/customHooks/useScreenWidth");
var styled_2 = require("../../../components/Modals/Modal/styled");
var getPositionStyles_1 = require("./utils/getPositionStyles");
var BulletIcon_1 = require("./comps/BulletIcon");
var HintsButton_1 = require("./comps/HintsButton");
var grey80 = colors_1.colors.grey80, black = colors_1.colors.black;
var Hints = function (_a) {
    var id = _a.id, hints = _a.hints, _b = _a.title, title = _b === void 0 ? "Hints" : _b, _c = _a.btnlabel, btnlabel = _c === void 0 ? "Hints" : _c, subtitle = _a.subtitle, disabled = _a.disabled;
    //get the context state
    var _d = (0, contextApi_1.useHintsContext)(), active = _d.active, setActive = _d.setActive;
    var screenWidth = (0, useScreenWidth_1.useScreenWidth)();
    var lightBoxRef = (0, react_1.useRef)();
    var _e = (0, react_1.useState)((0, getPositionStyles_1.getPositionStyles)("left")), styles = _e[0], setStyles = _e[1];
    //isStorybook is temporary hack to get correct with on storybook, since a story is getting renderend within an iframe, screen.width gives the incorrect width
    var isDesktop = screenWidth > (0, mixins_1.getBreakPoint)("md");
    (0, react_1.useEffect)(function () {
        if (!lightBoxRef.current)
            return;
        var lightBoxRect = lightBoxRef.current.getBoundingClientRect();
        // by default open on leftside, if the below condition is true than open at the bottom of hints
        //note for future: arrow comp is fixed and lightbox will move to place itself within the visible area
        if (lightBoxRect.left < 0) {
            setStyles((0, getPositionStyles_1.getPositionStyles)("bottom"));
            // setStyles({
            //   lightBox: { top: "4rem", right: "0" },
            //   arrow: { top: `none`, right: "3.5rem", transform: "none" },
            // });
        }
    }, [active]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(styled_1.StyledHints, { onClick: function () { return setActive(id); }, disabled: disabled },
            react_1.default.createElement(HintsButton_1.HintsButton, { id: id, btnLabel: btnlabel, onClick: function () { return setActive(id); } })),
        active === id ? (isDesktop ? (react_1.default.createElement("div", null,
            react_1.default.createElement(styled_1.StyledTriangle, { style: styles.arrow, id: id }),
            react_1.default.createElement(styled_1.StyledLightbox, { style: styles.lightBox, ref: lightBoxRef, id: id },
                react_1.default.createElement(styled_2.StyledModalHeaderStyle2Container, null,
                    react_1.default.createElement("div", { style: { position: "absolute", top: "-2.5rem", fontSize: 0 } },
                        react_1.default.createElement(DisplayIcon_1.DisplayIcon, { icon: "ModalBulbIcon" })),
                    react_1.default.createElement(styled_2.StyledModalHeaderStyle2Title, null,
                        react_1.default.createElement(Typo_1.SANS_3, { semibold: true, capitalize: true }, title),
                        subtitle ? (react_1.default.createElement(Typo_1.SANS_3_4, { capitalize: true, semibold: true, style: { flexGrow: "1" }, color: grey80 }, subtitle)) : null,
                        react_1.default.createElement(Buttons_1.ButtonGhost, { onClick: function () { return setActive(""); }, icon: "X" }))),
                react_1.default.createElement(styled_1.StyledLightBoxContent, null,
                    react_1.default.createElement(styled_1.StyledLightBoxList, null, hints.map(function (d) { return (react_1.default.createElement("li", null,
                        react_1.default.createElement(BulletIcon_1.BulletIcon, null),
                        react_1.default.createElement(Typo_1.SANS_3, null, d))); })))))) : (react_1.default.createElement(Modal_1.Modal, { isStorybook: true, headerStyle: "style2", id: "modal", title: title, onClose: function () { return setActive(""); } },
            react_1.default.createElement("div", { style: { padding: ".5rem 2rem" } },
                react_1.default.createElement(styled_1.StyledLightBoxList, null, hints.map(function (d) { return (react_1.default.createElement("li", null,
                    react_1.default.createElement("div", { style: { marginTop: ".5rem", lineHeight: 0 } },
                        react_1.default.createElement(DisplayIcon_1.DisplayIcon, { color: black, weight: "fill", icon: "Circle", size: 8 })),
                    react_1.default.createElement(Typo_1.SANS_3, null, d))); })))))) : null));
};
exports.default = Hints;
